/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Advantage,
    AdvantageFromJSON,
    AdvantageFromJSONTyped,
    AdvantageToJSON,
    CompanyInfo,
    CompanyInfoFromJSON,
    CompanyInfoFromJSONTyped,
    CompanyInfoToJSON,
    Factoid,
    FactoidFromJSON,
    FactoidFromJSONTyped,
    FactoidToJSON,
} from './';

/**
 * 
 * @export
 * @interface Complex
 */
export interface Complex {
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    readonly id?: number;
    /**
     * 
     * @type {Array<Factoid>}
     * @memberof Complex
     */
    factoids: Array<Factoid>;
    /**
     * 
     * @type {Array<Advantage>}
     * @memberof Complex
     */
    advantages: Array<Advantage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Complex
     */
    images: Array<string>;
    /**
     * 
     * @type {CompanyInfo}
     * @memberof Complex
     */
    company?: CompanyInfo;
    /**
     * 
     * @type {Date}
     * @memberof Complex
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Complex
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    sort?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    type?: ComplexTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    district?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    locality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    developer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    image?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    maxPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    minPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    maxArea?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Complex
     */
    minArea?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Complex
     */
    dateComplete?: string | null;
}

export function ComplexFromJSON(json: any): Complex {
    return ComplexFromJSONTyped(json, false);
}

export function ComplexFromJSONTyped(json: any, ignoreDiscriminator: boolean): Complex {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'factoids': ((json['factoids'] as Array<any>).map(FactoidFromJSON)),
        'advantages': ((json['advantages'] as Array<any>).map(AdvantageFromJSON)),
        'images': json['images'],
        'company': !exists(json, 'company') ? undefined : CompanyInfoFromJSON(json['company']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'district': !exists(json, 'district') ? undefined : json['district'],
        'locality': !exists(json, 'locality') ? undefined : json['locality'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'developer': !exists(json, 'developer') ? undefined : json['developer'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'maxPrice': !exists(json, 'maxPrice') ? undefined : json['maxPrice'],
        'minPrice': !exists(json, 'minPrice') ? undefined : json['minPrice'],
        'maxArea': !exists(json, 'maxArea') ? undefined : json['maxArea'],
        'minArea': !exists(json, 'minArea') ? undefined : json['minArea'],
        'dateComplete': !exists(json, 'dateComplete') ? undefined : json['dateComplete'],
    };
}

export function ComplexToJSON(value?: Complex | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'factoids': ((value.factoids as Array<any>).map(FactoidToJSON)),
        'advantages': ((value.advantages as Array<any>).map(AdvantageToJSON)),
        'images': value.images,
        'company': CompanyInfoToJSON(value.company),
        'title': value.title,
        'description': value.description,
        'sort': value.sort,
        'type': value.type,
        'region': value.region,
        'district': value.district,
        'locality': value.locality,
        'address': value.address,
        'developer': value.developer,
        'image': value.image,
        'maxPrice': value.maxPrice,
        'minPrice': value.minPrice,
        'maxArea': value.maxArea,
        'minArea': value.minArea,
        'dateComplete': value.dateComplete,
    };
}

/**
* @export
* @enum {string}
*/
export enum ComplexTypeEnum {
    Complex = 'complex',
    District = 'district',
    Quarter = 'quarter'
}


